<template>
    <div class="noNetwork">
        <div class="error_img">
            <img src="./../../assets/images/common/xiaohe4.png" alt="">
        </div>
        <p>网络异常了，点击<span @click="toReaload">刷新</span></p>
    </div>
</template>

<style lang="less" scoped>
.noNetwork{
    min-height: 100%;
    background: @expertFontColor255;
    text-align: center;
    overflow: hidden;
    .error_img{
        width: 100%;
        height: 128px;
        margin: 110px 0 20px;
        float: left;
        img{
            width: 128px;
            height: 128px;
        }
    }
    p{
        width: 100%;
        float: left;
        font-size:@indexFontSize14;
        color: @expertFontColor51; 
        span{
            color: @mainColor2;
            border-bottom:1px solid @mainColor2;
        }
    }
}
</style>


<script>
export default {
    name: "noNetwork",
    components: {},
    data() {
        return {};
    },
    computed: {},
    mounted() {
        
    },
    created() {},
    methods: {
        toReaload:function(){
            location.href=this.$route.query.redirect;
        }
    }
};
</script>
